/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Builder_Max_Steps_Hint_OrgInputs */



/**
* | output |
* | --- |
* | "The most actions this agent may take in a single run. Each action, like a search or a sent email, counts as one, and the run stops once the limit is reached...." |
*
* @param {Agent_Builder_Max_Steps_Hint_OrgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_hint_org = /** @type {((inputs: Agent_Builder_Max_Steps_Hint_OrgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_Hint_OrgInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Höchstzahl an Aktionen, die dieser Agent in einem Lauf ausführen darf. Jede Aktion, etwa eine Suche oder eine gesendete E-Mail, zählt einzeln; danach endet der Lauf. Ihre Organisation erlaubt höchstens ${i?.max}.`)
	return /** @type {LocalizedString} */ (`The most actions this agent may take in a single run. Each action, like a search or a sent email, counts as one, and the run stops once the limit is reached. Your organization allows at most ${i?.max}.`)
});